import { render, staticRenderFns } from "./drInfo.vue?vue&type=template&id=6d0b6fe2"
import script from "./drInfo.vue?vue&type=script&lang=js"
export * from "./drInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports